import { adminComponent } from './admin.component';

export const adminStateName = 'app.admin';

export const adminState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: adminStateName,
    url: '/admin',
    component: adminComponent.name,
    resolve: {
      v2: ($window, envService) => {
        $window.location.href = '/v2/admin';
      },
    },
    data: { requiresAuth: true },
  });
};
